'use client'
import { CreateAnchorLink } from '@/lib/postFunctions'
import { useState } from 'react'
import RenderRichTexComponent from '../rich-text-render/richTextRender'
import EmbeddedGalleryComponent from '../galleries/embedded-gallery/embeddedGallery'
import { AvatarGroup } from '../avatar-group/AvatarGroup'
import PopupComponent from '../popup/popup'
import FlowiteIconComponent from '../flowbite-icon/flowbiteIcon'
import { MediaBlock } from '@/payload-types'
import ProfileList from '../profile-list/profileList'
import { Case, Individualprofile, Publicprofile } from '@/payload-types'
import { Media } from '@/payload-types'
import { MediaCarousel } from '../galleries/media-carousel/mediaCarousel'
import ImageComponent from '../media/imageComponent'
import { CaseDetails } from './caseDetails'
interface IProps {
  caseData?: Case
  publicName?: string
  media?: (string | Media)[]
  individualId?: string
  timeStamp?: {
    value?: string | null
    mediaId?: (string | null) | Media
  }[]
}

export const ProfileSingleCase = ({ caseData, media, individualId, timeStamp }: IProps) => {
  const [showProfilesPopover, setShowProfilesPopover] = useState(false)
  const [showCaseImagePopup, setShowCaseImagePopup] = useState(false)
  const [selectedCaseImage, setSelectedCaseImage] = useState<string | null>(null)
  if (!caseData) return null
  console.log("relatedProfiles", caseData.profiles);
  
  const relatedProfiles = caseData.profiles?.filter(
    (p) =>
      typeof p === 'object' &&
      p.id !== individualId &&
      p.publicProfile !== null &&
      typeof p.publicProfile === 'object' &&
      p.publicProfile._status === 'published',
  ) as Individualprofile[]
  const caseMedia: MediaBlock[] =
    caseData.topMedias?.map((m) => ({ media: m, blockType: 'mediaBlock' })) ?? []
  const individualsMedia = media?.map((m) => {
    if (typeof m === 'object') {
      const mediaBelongToCase = m.belongToCase?.some(
        (caseRef) => typeof caseRef === 'object' && caseRef.id === caseData.id,
      )
      return mediaBelongToCase ? m : null
    }
  })
  const filteredMedia = individualsMedia?.filter((m) => m !== undefined && m !== null) ?? []

  const mediaBlocks: MediaBlock[] =
    filteredMedia?.map((m) => ({
      media: m,
      blockType: 'mediaBlock',
    })) ?? []

  const uniqueMediaBlocks = [...mediaBlocks, ...(caseMedia ?? [])].reduce((unique, block) => {
    const exists = unique.some(
      (b) =>
        typeof b.media === 'object' &&
        typeof block.media === 'object' &&
        b.media.id === block.media.id,
    )
    const isParentOfOther = [...mediaBlocks, ...(caseMedia ?? [])].some(
      (otherBlock) =>
        typeof otherBlock.media === 'object' &&
        typeof block.media === 'object' &&
        typeof otherBlock.media.parentMedia === 'object' &&
        otherBlock.media.parentMedia?.id === block.media.id,
    )
    return exists || isParentOfOther ? unique : [...unique, block]
  }, [] as MediaBlock[])

  return (
    <>
      <div
        id={CreateAnchorLink(caseData.title ?? '')?.href?.split('#')[1]}
        key={caseData.id}
        className="border-b border-b-gray-200 last:border-b-0"
      >
        <div className="flex justify-between border-b pb-2 pt-6 border-black mb-2 items-end">
          <h2 className="font-bold text-[25px] md:block leading-[30px]">{caseData.title}</h2>
          {/* TODO: Add link to case when we have a case page */}
          {/* <Link
            href={caseUrl}
            className="whitespace-nowrap flex text-gray-600 text-sm flex-nowrap	items-center ms-4 h-fit"
          >
            View {caseData.type === 'event' ? 'Event' : 'Incident'}
            <FlowiteIconComponent iconType={'ArrowRight'} />
          </Link> */}
        </div>
        <CaseDetails caseData={caseData} />
        <RenderRichTexComponent richTextField={caseData.shortDescription} inline={true} />
        <div className="pt-2">
          {/* Filter out media that is not related to the case */}
          {uniqueMediaBlocks.length > 2 ? (
            <EmbeddedGalleryComponent
              mediaBlockes={uniqueMediaBlocks}
              onImageClick={(imageSrc) => {
                setSelectedCaseImage(imageSrc)
                setShowCaseImagePopup(true)
              }}
            />
          ) : (
            <MediaCarousel
            timeStamp={timeStamp}
              media={uniqueMediaBlocks.map((m) => m.media)}
              onImageClick={(imageSrc) => {
                setSelectedCaseImage(imageSrc)
                setShowCaseImagePopup(true)
              }}
            />
          )}
          {showCaseImagePopup && selectedCaseImage && (
            <PopupComponent onClose={() => setShowCaseImagePopup(false)}>
              <ImageComponent src={selectedCaseImage} alt="Selected image" />
            </PopupComponent>
          )}
        </div>
        <div className="py-4 flex flex-col gap-1">
          {relatedProfiles.length > 0 && (
            <span className="text-sm font-bold">
              {'Profiles Related to'}
              {` ${caseData.title}`}
            </span>
          )}
          <button onClick={() => setShowProfilesPopover(true)} className="w-fit">
            <AvatarGroup profiles={relatedProfiles} maxDisplay={3} />
          </button>
        </div>
      </div>
      {showProfilesPopover && (
        <PopupComponent onClose={() => setShowProfilesPopover(false)}>
          <div>
            <div className="flex justify-end m-2">
              <button onClick={() => setShowProfilesPopover(false)} className="w-fit">
                <FlowiteIconComponent className="text-white" iconType={'Close'} />
              </button>
            </div>
            <div className="bg-white rounded-lg m-2 mt-0">
              <div className="p-2 max-w-[850px]">
                <div className="font-bold text-lg w-full border-b border-b-black mb-6 text-start">
                  Profiles
                </div>
                <ProfileList
                  profileListData={{
                    blockType: 'profileList',
                    listFormat: 'compactFormat',
                    profileList: relatedProfiles
                      .filter((p) => typeof p.publicProfile === 'object')
                      .map((p) => ({
                        profile: {
                          relationTo: 'publicprofiles',
                          value: p.publicProfile as Publicprofile,
                        },
                      })),
                  }}
                />
              </div>
            </div>
          </div>
        </PopupComponent>
      )}
    </>
  )
}
